import { writable } from "svelte/store";
import { tableViewMode } from "./constants";
import { defaultPageSizePaginationTableView } from "../../constants";

const defaultPlansStoreState = {
    plans: [],
    total: 0,
    currentPageIndex: 0,
    pageSize: defaultPageSizePaginationTableView,
    loading: true
};

const createPlansStore = () => {
    const planStore = writable(defaultPlansStoreState);

    return {
        ...planStore,
        reset: () => planStore.set(defaultPlansStoreState)
    };
};

export const allPlans = createPlansStore();

export const backLink = writable({ url: "", label: "" });

const createPlanFilesStatusStore = () => {
    const { subscribe, update } = writable(new Map());

    const updateFileStatus = (file, planId, columnId) =>
        update(files => {
            files.set(file.name, { ...file, planId, columnId });

            return files;
        });

    const dismissError = fileName =>
        update(files => {
            files.delete(fileName);

            return files;
        });

    return {
        subscribe,
        updateFileStatus,
        dismissError
    };
};

export const planFilesStatus = createPlanFilesStatusStore();

const defaultTopicsStoreState = {
    topics: [],
    total: 0,
    currentPageIndex: 0,
    pageSize: defaultPageSizePaginationTableView,
    loading: true
};

const createTopicsStore = () => {
    const topicsStore = writable(defaultTopicsStoreState);

    return {
        ...topicsStore,
        reset: () => topicsStore.set(defaultTopicsStoreState)
    };
};

export const allTopics = createTopicsStore();

export const isAnyTopicsInCourse = writable();

export const mode = writable(tableViewMode.plans);

export const topicFilterIds = writable([]);

export const areAllPlansSelected = writable(false);

export const selectedPlanIds = writable(new Set([]));

export const planData = writable({});

export const planIdsForCourseStore = writable({});
